import { DialogTitle } from '@savvy-kit/components/dialog';
import { Text } from '@savvy-kit/foundations/text';
import { cn } from '@savvy-kit/lib/utils';
import TrackedButton from 'src/components/tracked/tracked-button';
import TrackedDialog from 'src/components/tracked/tracked-dialog';

import { useIsSmallScreen } from '@savvy/deprecated-shared/hooks/use-is-small-screen';

type Props = {
  readonly descriptionRow: React.ReactElement;
  readonly deletionText: string;
  readonly deleteButtonText: string;
  readonly isLoading: boolean;
  readonly onClose: () => void;
  readonly onRemove: () => void;
};

export default function RemoveItemDialog({
  descriptionRow,
  deletionText,
  deleteButtonText,
  isLoading,
  onClose,
  onRemove,
}: Props) {
  const isSmallScreen = useIsSmallScreen();
  return (
    <TrackedDialog
      elementName="remove-item-dialog"
      open
      onOpenChange={(nextOpen) => !nextOpen && onClose()}
      size={isSmallScreen ? 'fullscreen' : undefined}
      className={cn('flex flex-col p-6', !isSmallScreen && 'max-h-[85vh]')}
    >
      <DialogTitle className="sr-only">Remove item</DialogTitle>
      <div className="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto">
        {descriptionRow}
        <Text>{deletionText}</Text>
        <div className="flex flex-row gap-4 justify-end">
          <TrackedButton elementName="portfolio-item-cancel-remove-item-button" variant="secondary" onClick={onClose}>
            Cancel
          </TrackedButton>
          <TrackedButton
            elementName="portfolio-item-remove-item-button"
            isLoading={isLoading}
            variant="destructive"
            onClick={onRemove}
          >
            {deleteButtonText}
          </TrackedButton>
        </div>
      </div>
    </TrackedDialog>
  );
}
